import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/icons/jb-search-icon/jb-search-icon.css.ts
var jb_search_icon_css_default = i`:host{font-family:var(--theme-font-regular-family, VerlagSSm, Tahoma, sans-serif);font-weight:var(--theme-font-regular-weight, 400)}:host{font-size:var(--theme-typo-p-mini-highlight-desktop-fontsize, 0.813rem);line-height:var(--theme-typo-p-mini-highlight-desktop-lineheight, 1.25rem)}:host{align-items:center;color:inherit;cursor:pointer;display:var(--display, inline-flex);gap:var(--theme-spacing-3xs)}:host(:hover) svg{transform:rotate(75deg)}svg{block-size:24px;display:inline-block;inline-size:24px;margin-inline-end:-3px;overflow:visible;padding:2px;transform:rotate(0);transition:transform .5s ease-in-out 0s}`;

export {
  jb_search_icon_css_default
};
